import { HTTP } from '@/core';

export class OrderBillDocumentService {
  static async store(orderId: string, file: string): Promise<{ id: string; url: string }> {
    const { data } = await HTTP.post(`orders/${orderId}/bill/documents`, { file });

    return data;
  }

  static async remove(orderId: string, documentId: string): Promise<void> {
    await HTTP.delete(`orders/${orderId}/bill/documents/${documentId}`);
  }
}
